// 首页中部资源位管理
import http from "@/jslibs/axios/http";

// 首页中部资源位更新
export const edit = (data) => http.post("/v1/cms/IndexMiddleResource", data);

// 首页中部资源位详情
export const detail = (data) => http.get("/v1/cms/IndexMiddleResource", data);
